//适配屏幕宽度
const MAX_WIDTH = 750;

const IMGCDN = "https://afc.oss-cn-shanghai.aliyuncs.com/AFC/";

const IMGVERSION =
  process.env.NODE_ENV === "production"
    ? Math.floor(Math.random() * 1000000) + 1
    : 13;

function AdaptationScreen(sFn, bFn) {
  if (window.innerWidth <= MAX_WIDTH) {
    //console.log('小屏幕', "=========")
    sFn && sFn();
  } else {
    //console.log('大屏幕', "============")
    bFn && bFn();
  }
  window.addEventListener("resize", () => {
    if (window.innerWidth <= MAX_WIDTH) {
      //console.log('小屏幕', "=========")
      sFn && sFn();
    } else {
      //console.log('大屏幕', "============")
      bFn && bFn();
    }
  });
}

//屏幕比例适配
function screenPropFn(Fn) {
  var pix = window.innerWidth / window.innerHeight;
  var screenProp = "";
  if (pix < 0.55) {
    screenProp = "screen189";
  }
  if (pix >= 0.56) {
    screenProp = "screen159";
  }

  Fn && Fn(screenProp);
}

function parseQueryString(url) {
  // 提取查询字符串
  const queryString = url.split("?")[1];

  // 使用 URLSearchParams 解析查询字符串
  const params = new URLSearchParams(queryString);

  // 将 URLSearchParams 转换为对象
  const queryObject = {};
  params.forEach((value, key) => {
    // 尝试将 value 转换为数字，如果转换失败则保留原值
    const parsedValue = isNaN(value) ? value : Number(value);
    queryObject[key] = parsedValue;
  });

  return queryObject;
}

module.exports = {
  pageSize: 10, //默认分页10条
  websiteEnglishName: "STELLANTIS AUTOMOTIVE FINANCE",
  appointmentLoan: "http://jfs-test.beyondh5.com/index.html",
  designDraftWidth: 1920, //设计稿宽度
  max_width: MAX_WIDTH,
  fileUrl: "https://afc.oss-cn-shanghai.aliyuncs.com",
  wxAppLink: "https://wxaurl.cn/r0erq8sbXpm",
  imgCDN: IMGCDN, //图片cdn
  imgVersion: IMGVERSION, //图片版本
  parseQueryString, //将 URL 查询字符串转换为对象的函数
  brandList: [],
  AdaptationScreen,
  screenPropFn,
  loanAppointmentJumpConnection: [
    {
      id: 0,
      name: "玛莎拉蒂",
      name_en: "MA",
      params_name: "玛莎拉蒂",
      brandName: "玛莎拉蒂",
      active: true, //link: "https://mafs.stellantisafc.com.cn/index.html?source=留资-线上-官网",
      link: "/aboutUs/loanAppointment",
      query: {
        financialIndex: 0,
      },
    },
    {
      id: 1,
      name: "阿尔法罗密欧",
      name_en: "AR",
      params_name: "阿尔法罗密欧",
      brandName: "阿尔法罗密欧",
      active: false, //link: "https://arfs.stellantisafc.com.cn/index.html?source=留资-线上-官网"
      link: "/aboutUs/loanAppointment",
      query: {
        financialIndex: 1,
      },
    },
    {
      id: 2,
      name: "标致",
      name_en: "Peugeot",
      params_name: "标致",
      brandName: "标致",
      active: false, //link: "https://pfs.stellantisafc.com.cn/index.html?source=留资-线上-官网"
      link: "/aboutUs/loanAppointment",
      query: {
        financialIndex: 2,
      },
    },
    {
      id: 3,
      name: "Jeep",
      name_en: "Jeep",
      params_name: "克莱斯勒",
      brandName: "Jeep",
      active: false, //link: "https://jfs.stellantisafc.com.cn/index.html?source=留资-线上-官网",
      link: "/aboutUs/loanAppointment",
      query: {
        financialIndex: 3,
      },
    },
    {
      id: 4,
      name: "南京依维柯",
      name_en: "naveco",
      params_name: "南京依维柯",
      brandName: "依维柯",
      active: false, //link: "https://sfs.stellantisafc.com.cn/index.html?source=留资-线上-官网"
      link: "/aboutUs/loanAppointment",
      query: {
        financialIndex: 4,
      },
    },
    //{
    //  id: 5,
    //  name: 'DS',
    //  name_en: 'DS',
    //  params_name: "谛艾仕",
    //  brandName: "DS",
    //  noData: true,
    //  active: false,
    //  //link: "https://sfs.stellantisafc.com.cn/index.html?source=留资-线上-官网"
    //  link: "/aboutUs/loanAppointment",
    //  query: {
    //    financialIndex: 5,
    //  }
    //},
    {
      id: 6,
      name: "迈凯伦",
      name_en: "McLaren",
      params_name: "迈凯伦",
      brandName: "迈凯伦",
      active: false, //link: "https://mfs.stellantisafc.com.cn/index.html?source=留资-线上-官网"
      link: "/aboutUs/loanAppointment",
      query: {
        financialIndex: 6,
      },
    },
    {
      id: 7,
      name: "法拉利",
      name_en: "ferrari",
      params_name: "法拉利",
      brandName: "法拉利",
      active: false, //link: "https://mfs.stellantisafc.com.cn/index.html?source=留资-线上-官网"
      link: "/aboutUs/loanAppointment",
      query: {
        financialIndex: 7,
      },
    },
  ],
  listOfVehicleModels: [], //车型列表
};
